import { render, staticRenderFns } from "./StatementOfUseGame.vue?vue&type=template&id=49db704c&"
import script from "./StatementOfUseGame.vue?vue&type=script&lang=js&"
export * from "./StatementOfUseGame.vue?vue&type=script&lang=js&"
import style0 from "./StatementOfUseGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatementOfUseGame.vue"
export default component.exports